import { render, staticRenderFns } from "./ClientSection.vue?vue&type=template&id=842128cc&scoped=true"
import script from "./ClientSection.vue?vue&type=script&lang=js"
export * from "./ClientSection.vue?vue&type=script&lang=js"
import style0 from "./ClientSection.vue?vue&type=style&index=0&id=842128cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842128cc",
  null
  
)

export default component.exports